module.exports = __webpack_public_path__ + "static/img/case_banner_08.f267bb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_08.png
// module id = k9i+
// module chunks = 34